import { getAppInjector } from '../di/app-injector';
import { Logger } from './logger.service';

export class Log {
  private static _logger: Logger | null = null;

  private static get logger(): Logger {
    if (!this._logger) this._logger = getAppInjector().get(Logger);
    return this._logger;
  }

  static setLevel = (...a: Parameters<Logger['setLevel']>) => this.logger.setLevel(...a);
  static trace    = (...a: Parameters<Logger['trace']>)    => this.logger.trace(...a);
  static debug    = (...a: Parameters<Logger['debug']>)    => this.logger.debug(...a);
  static info     = (...a: Parameters<Logger['info']>)     => this.logger.info(...a);
  static warn     = (...a: Parameters<Logger['warn']>)     => this.logger.warn(...a);
  static error    = (...a: Parameters<Logger['error']>)    => this.logger.error(...a);
}
